import { render } from "./MultiStepForm.vue?vue&type=template&id=1572b421&scoped=true"
import script from "./MultiStepForm.vue?vue&type=script&lang=js"
export * from "./MultiStepForm.vue?vue&type=script&lang=js"

import "./MultiStepForm.vue?vue&type=style&index=0&id=1572b421&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1572b421"]])

export default __exports__